import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { IconSize } from '../../Icons/IconWrap';
export default function useIconSizeForButtonSize(buttonSize) {
    const isUpdatedButtonSize = useFlag('ds_update_btn_medium');
    if (isUpdatedButtonSize) {
        switch(buttonSize){
            case 'small':
                return IconSize.SMALLER;
            case 'medium':
                return IconSize.SMALLER;
            default:
                return IconSize.MEDIUM;
        }
    }
    return buttonSize === 'small' ? IconSize.SMALLER : IconSize.MEDIUM;
}

//# sourceMappingURL=useIconSizeForButtonSize.js.map